export const HOME = {
  heroCtaPrimary: 'hero-cta-primary',
  heroCtaSecondary: 'hero-cta-secondary',
  audienceToggleCreator: 'audience-toggle-creator',
  audienceToggleBrand: 'audience-toggle-brand',
  langToggle: 'nav-lang-toggle',
  navLogin: 'nav-login-btn',
  navRegister: 'nav-register-btn',
  navLogout: 'nav-logout-btn',
  navDashboard: 'nav-dashboard-btn',
  pricingFreeCta: 'pricing-free-cta',
  pricingProCta: 'pricing-pro-cta',
  leadFormSubmit: 'lead-form-submit',
  leadFormName: 'lead-form-name',
  leadFormEmail: 'lead-form-email',
  leadFormHandle: 'lead-form-handle',
  leadFormCompany: 'lead-form-company',
  leadFormMessage: 'lead-form-message',
  faqItem: (i) => `faq-item-${i}`,
};
